import React, { useEffect, useReducer, useState } from "react";
import { Button, Grid, Typography } from "@material-ui/core";
import { useParams } from "react-router-dom";
import DeleteIcon from "@material-ui/icons/Delete";
import { Alert } from "@material-ui/lab";
import { AddIcon, DataGrid } from "@material-ui/data-grid";
import { useTranslation } from "react-i18next";

import useStyles from "./PatientAssociation.style.";

import ChildrenLoading from "../../../components/ChildrenLoading";
import Cookies from "universal-cookie";
import CustomNoRowsOverlay from "../../../components/CustomNoRowsOverlay";

const cookies = new Cookies();
const PatientGrid = (props) => {
  return (
    <DataGrid
      checkboxSelection
      pageSize={10}
      autoHeight="true"
      disableSelectionOnClick
      density="compact"
      {...props}
    />
  );
};

const PatientAssociation = () => {
  const classes = useStyles();
  const { providerId } = useParams();
  const { t } = useTranslation();

  const [updated, forceUpdate] = useReducer((x) => x + 1, 0);

  const [error, setError] = useState("");
  const [loadingProvider, setLoadingProvider] = useState(true);
  const [loadingPatients, setLoadingPatients] = useState(true);
  const [loadingAssociatedPatients, setLoadingAssociatedPatients] =
    useState(true);
  const [provider, setProvider] = useState({});
  const [patients, setPatients] = useState([]);
  const [associatedPatients, setAssociatedPatients] = useState([]);
  const [associationResult, setAssociationResult] = useState();
  const [selectedRemovedPatientRows, setSelectedRemovedPatientRows] = useState(
    []
  );
  const [selectedAssociatedPatientRows, setSelectedAssociatedPatientRows] =
    useState([]);



  const AllPatientsHeader = () => {
    return (
      <Typography variant="h5" className={classes.gridTitle}>
        {t("module.provider.patientAssociation.gridHeader.allPatient")}
      </Typography>
    );
  };
  const AsssociatedPatientsHeader = () => {
    return (
      <Typography variant="h5" className={classes.gridTitle}>
        {t("module.provider.patientAssociation.gridHeader.associatedPatient")}
      </Typography>
    );
  };
  const allPatientsColumns = [
    { field: "fullName", headerName: t("common.substantive.name"), flex: 1 },
  ];
  const associatedPatientsColumns = [
    { field: "fullName", headerName: t("common.substantive.name"), flex: 1 },
  ];


  useEffect(() => {
    const getproviderorgpatients = async () => {
      try {
        let response = await fetch(
          `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_PROVIDER_PROVIDERORGPATIENTS}/${providerId}`,
          {
            headers: {
              "X-ACCESS-TOKEN": cookies.get("token"),
            },
          }
        );
        let json = await response.json();
        if (!response.ok) {
          setError(json.message);
          return;
        }

        setPatients(
          json && json.map((patient) => ({
            id: patient._id,
            fullName: `${patient.lastName}, ${patient.firstName}`,
          }))
        );

      } catch (error) {
        console.log(error);
        setError(
          `${t(
            "module.provider.patientAssociation.message.patientDataLoadFailure"
          )}. ${t("common.message.error.seeLog")}.`
        );
      } finally {
        setLoadingPatients(false);
      }
    };

    getproviderorgpatients()
  }, [])



  useEffect(() => {
    const getProviderData = async () => {
      try {
        let response = await fetch(
          `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_PROVIDER}/${providerId}`,
          {
            headers: {
              "X-ACCESS-TOKEN": cookies.get("token"),
            },
          }
        );
        let json = await response.json();
        if (!response.ok) {
          setError(json.message);
          return;
        }
        setProvider({ ...json });
      } catch (error) {
        console.log(error);
        setError(
          `${t(
            "module.provider.patientAssociation.message.providerDataLoadFailure"
          )}. ${t("common.message.error.seeLog")}.`
        );
      } finally {
        setLoadingProvider(false);
      }
    };

    getProviderData();

  }, [providerId, t]);

  useEffect(() => {
    const getAssociatedPatients = async () => {
      try {
        let response = await fetch(
          `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_PROVIDER}/${providerId}/patients`,
          {
            headers: {
              "X-ACCESS-TOKEN": cookies.get("token"),
            },
          }
        );
        let json = await response.json();
        if (!response.ok) {
          setError(json.message);
          return;
        } else {
          setAssociatedPatients(
            json.map((patient, index) => {
              if (patient.user)
                return {
                  id: patient.user._id,
                  fullName: `${patient.user.lastName}, ${patient.user.firstName}`,
                };
            })
          );
        }
      } catch (error) {
        console.log(error);
        setError(
          `${t(
            "module.provider.patientAssociation.message.associatedPatientDataLoadFailure"
          )}. ${t("common.message.error.seeLog")}.`
        );
      } finally {
        setLoadingAssociatedPatients(false);
      }
    };

    getAssociatedPatients();
  }, [updated, providerId, t]);

  const handleAssociation = () => async (e) => {
    if (
      selectedAssociatedPatientRows &&
      selectedAssociatedPatientRows[0] &&
      selectedAssociatedPatientRows[0].length > 0
    ) {
      try {
        let response = await fetch(
          `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_PROVIDER_ADD_PATIENT}`,
          {
            method: "post",
            headers: {
              "X-ACCESS-TOKEN": cookies.get("token"),
            },
            body: new URLSearchParams({
              providerId: provider._id,
              patientId: [selectedAssociatedPatientRows],
            }),
          }
        );

        if (!response.ok) {
          let json = await response.json();
          setAssociationResult({ severity: "error", message: json.message });
          setSelectedAssociatedPatientRows([]);
          return;
        }
        setAssociationResult({
          severity: "success",
          message: t(
            "module.provider.patientAssociation.message.patientAssociationSuccess"
          ),
        });
        setSelectedAssociatedPatientRows([]);

        forceUpdate();
      } catch (error) {
        console.log(error);
        setAssociationResult({
          severity: "error",
          message: t(
            "module.provider.patientAssociation.message.patientAssociationFailure"
          ),
        });
        setSelectedAssociatedPatientRows([]);
      }
    } else {
      setAssociationResult({
        severity: "error",
        message: "Please select the Patients",
      });
    }
  };

  const handleDisassociation = () => async (e) => {
    if (
      selectedRemovedPatientRows &&
      selectedRemovedPatientRows[0] &&
      selectedRemovedPatientRows[0].length > 0
    ) {
      try {
        let response = await fetch(
          `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_PROVIDER_REMOVE_PATIENT}`,
          {
            method: "post",
            headers: {
              "X-ACCESS-TOKEN": cookies.get("token"),
            },
            body: new URLSearchParams({
              providerId: provider._id,
              patientId: [selectedRemovedPatientRows],
            }),
          }
        );

        if (!response.ok) {
          let json = await response.json();
          setAssociationResult({ severity: "error", message: json.message });
          return;
        }
        setAssociationResult({
          severity: "success",
          message: t(
            "module.provider.patientAssociation.message.patientRemovalSuccess"
          ),
        });
        forceUpdate();
      } catch (error) {
        console.log(error);
        setAssociationResult({
          severity: "error",
          message: t(
            "module.provider.patientAssociation.message.patientRemovalFailure"
          ),
        });
      }
    } else {
      setAssociationResult({
        severity: "error",
        message: "Please select the Patients",
      });
    }
  };

  if (loadingProvider) return <ChildrenLoading />;

  if (error) return <Alert severity="error">{error}</Alert>;

  return (
    <>
      <Typography variant="h4" className={classes.title}>
        {provider.firstName}'s {t("common.substantive.patients")}
      </Typography>
      {associationResult && (
        <Alert className={classes.alert} severity={associationResult.severity}>
          {associationResult.message}
        </Alert>
      )}

      <Grid container spacing={1}>
        <Grid item xs={12} md={6} direction="column">
          {/* handle DeAssociate */}
          <Button
            variant="contained"
            color="primary"
            size="small"
            startIcon={<DeleteIcon />}
            onClick={handleDisassociation()}
          >
            {t("common.verb.remove")}
          </Button>
          {/* Associated Patients Grid */}
          <PatientGrid
            onSelectionChange={(data) => {
              setSelectedRemovedPatientRows([data.rowIds]);
            }}
            rows={associatedPatients}
            columns={associatedPatientsColumns}
            loading={loadingAssociatedPatients}
            components={{
              header: AsssociatedPatientsHeader,
              noRowsOverlay: CustomNoRowsOverlay,
            }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          {/* handle Association */}
          <Button
            variant="contained"
            color="primary"
            size="small"
            startIcon={<AddIcon />}
            onClick={handleAssociation()}
          >
            {t("common.verb.associate")}
          </Button>
          {/* All Patients */}
          <PatientGrid
            onSelectionChange={(data) => {
              setSelectedAssociatedPatientRows([data.rowIds]);
            }}
            rows={patients}
            columns={allPatientsColumns}
            loading={loadingPatients}
            components={{
              header: AllPatientsHeader,
              noRowsOverlay: CustomNoRowsOverlay,
            }}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default PatientAssociation;
